import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

const FEATURED_CITIES = [
  ["Cleveland", "cleveland", "Cuyahoga County"],
  ["Columbus", "columbus", "Franklin County"],
  ["Cincinnati", "cincinnati", "Hamilton County"],
  ["Akron", "akron", "Summit County"],
  ["Toledo", "toledo", "Lucas County"],
  ["Dayton", "dayton", "Montgomery County"],
  ["Parma", "parma", "Cuyahoga County"],
  ["Canton", "canton", "Stark County"],
  ["Youngstown", "youngstown", "Mahoning County"],
  ["Lorain", "lorain", "Lorain County"],
];

export default function CitiesPreview() {
  return (
    <section className="section bg-forest text-bone" data-testid="cities-section">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-terracotta mb-3">Local to Every Ohio City</div>
            <h2 className="text-3xl md:text-5xl font-display font-bold text-bone tracking-tight mb-4 text-balance">
              From the Lake to the River. We cover Ohio.
            </h2>
            <p className="text-base md:text-lg text-bone/70 leading-relaxed">
              Local attorneys who know your county courts, hospitals, and roadways. Browse by city.
            </p>
          </div>
          <Link to="/ohio-cities" className="btn-primary self-start" data-testid="all-cities-button">
            View all Ohio cities
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
          {FEATURED_CITIES.map(([name, slug, county]) => (
            <Link
              key={slug}
              to={`/ohio-cities/${slug}`}
              className="group bg-bone/5 hover:bg-terracotta hover:text-white border border-bone/10 rounded-xl p-4 transition-all duration-200"
              data-testid={`city-card-${slug}`}
            >
              <div className="flex items-center gap-2 mb-1">
                <MapPin className="w-3.5 h-3.5 opacity-60" />
                <div className="text-[10px] font-bold tracking-wider uppercase opacity-60 group-hover:opacity-100">{county}</div>
              </div>
              <div className="font-display font-bold text-lg leading-tight">{name}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
